import React, { useCallback } from 'react';
import { getIn, useFormikContext } from 'formik';
import styled from 'styled-components';
import { UdsFC } from '../../../types';
import { DatePicker, DatePickerProps } from '../../DatePicker/DatePicker';
import { useAppFormControlContext } from './appFormControlContext';
import { appFormDataTestFactory } from './appFormDataTestFactory';

export const AppFormDatePicker: UdsFC<Partial<DatePickerProps>> = (props) => {
  const context = useAppFormControlContext();
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const name = 'name' in props ? props.name : context.name;
  const value = 'value' in props ? props.value : name ? getIn(values, name) : undefined;
  const error = 'error' in props ? props.error : !!context.error;
  const onChange = props.onChange;
  const handleOnChange = useCallback(
    (value: Date | null) => {
      if (onChange) {
        onChange(value);
      } else if (name) {
        setFieldTouched(name);
        setFieldValue(name, value);
      }
    },
    [name, onChange, setFieldTouched, setFieldValue]
  );
  return (
    <StyledDatePickerWrapper className={props.fullWidth ? 'fullWidth' : ''}>
      <DatePicker
        {...props}
        value={value}
        error={error}
        onChange={handleOnChange}
        dataTest={appFormDataTestFactory(props.dataTest ?? context.dataTest).input}
      />
    </StyledDatePickerWrapper>
  );
};

const StyledDatePickerWrapper = styled.div`
  &.fullWidth {
    .MuiFormControl-root.MuiTextField-root {
      width: 100%;
    }
  }
`;
